import {
  IUnifiedPickerTabConfig,
  TColor,
  TPickerType,
} from './unifiedColorPicker.types'

const mapInitialColorToTab = ({
  tabsConfig,
  initialValue,
}: {
  tabsConfig: IUnifiedPickerTabConfig[]
  initialValue: string
}): TColor[] => {
  const hexRegexp = /^#([0-9a-f]{3}){1,2}$/i
  let usedPickerType: TPickerType = null

  const boilerplatePickerConfig = [
    { value: '', label: '' },
    { value: '', label: '' },
  ]

  if (!initialValue) return boilerplatePickerConfig

  if (initialValue.includes('Pantone')) {
    usedPickerType = 'pantone-input'
  }

  if (hexRegexp.test(initialValue)) {
    usedPickerType = 'hex'
  }

  if (!usedPickerType) usedPickerType = 'list'

  const targetTabIndex = Math.max(
    tabsConfig.findIndex((x) => {
      // "list" and "categories" pickers have the same color format
      // and for legace setup there is no way to differentiate them, so we are checking for both
      if (usedPickerType === 'list') {
        return x.pickerType === 'list' || x.pickerType === 'categories'
      }
      return x.pickerType === usedPickerType
    }),
    0
  )

  boilerplatePickerConfig.splice(targetTabIndex, 1, {
    value: initialValue,
    label: '',
  })
  return boilerplatePickerConfig
}

export { mapInitialColorToTab }
